import { useState } from "react";
import { AddForm, UploadFileComp, useTitle } from "../../components";
import { useAddDesignationMutation, useCreateBannerMutation } from "../../store";
import { ToastContainer, toast } from "react-toastify";
import { toastOptions } from "../../utils/error";

export default function AddDesignation() {
    useTitle("Add Designation");

    const [file, setFile] = useState(null);
    const [info, setInfo] = useState({ link: null, client_name: null });
    const [UpdateCompError, setUpdateCompError] = useState(null);

    const [addDesignation, { isLoading, isSuccess, error }] =
        useAddDesignationMutation();
    console.log(UpdateCompError);
    //submit
    const handleSubmit = (e) => {
        e.preventDefault();
        addDesignation({ designation: info.designation });
    };

    const bannerAttr = [
        {
            type: "text",
            col: 12,
            props: {
                label: "Designation",
                name: "designation",
                placeholder: "Enter Designation",
            },
        },
    ];

    return (
        <AddForm
            title="Add Designation"
            data={info}
            setData={setInfo}
            inputFieldProps={bannerAttr}
            submitHandler={handleSubmit}
            target="/admin/designation"
            successMessage="Designation Added Successfully!"
            reducerProps={{ loading: isLoading, error: error, success: isSuccess }}
        >
            <ToastContainer />
        </AddForm>
    );
}